import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RoleMSService } from 'app/services/utils/roleMS.service';
import { Observable } from 'rxjs/Observable';
import { isUndefined } from 'util';
import { AcmType, AcmTypehasReason, AcmTypeOperation } from '../../../../models/loyalty-acm-type.model';
import { AcmTypeHasReasonService } from '../../../../services/loyalty/acm-type-has-reason.service';
import { LoyaltyAcmTypeService } from '../../../../services/loyalty/loyalty-acm-type.service';
import { LoyaltyReasonService } from '../../../../services/loyalty/reason.service';
import { LoyaltyParamsService } from 'app/services/loyalty/params.service';

@Component({
  selector: 'app-form-acm-type-loyalty',
  templateUrl: './form-acm-type-loyalty.component.html',
  styleUrls: ['./form-acm-type-loyalty.component.css']
})
export class FormAcmTypeLoyaltyComponent implements OnInit {

  fields: any;
  reasonFields: any;
  flg_operations: AcmTypeOperation;
  translations: any;
  public invalidSubmit: boolean;

  form: FormGroup;
  @Input() acmTypeId: string;
  @Input() editMode: boolean;
  reasonForm: Array<FormGroup>;

  reasonsList: { value: number, label: string }[] = sessionStorage.getItem('acmTypeReasons') ? JSON.parse(sessionStorage.getItem('acmTypeReasons')) : [{ value: null, label: '' }];
  rolesList: { value: number, label: string }[] = sessionStorage.getItem('acmTypeRoles') ? JSON.parse(sessionStorage.getItem('acmTypeRoles')) : [{ value: null, label: '' }];

  listTypeI: { value: string, label: string }[] = sessionStorage.getItem('acmTypeListTypeI') ? JSON.parse(sessionStorage.getItem('acmTypeListTypeI')) : [{ value: null, label: '' }];
  listTypeO: { value: string, label: string }[] = sessionStorage.getItem('acmTypeListTypeO') ? JSON.parse(sessionStorage.getItem('acmTypeListTypeO')) : [{ value: null, label: '' }];

  constructor(
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private acmTypeService: LoyaltyAcmTypeService,
    private acmTypeHasReasonService: AcmTypeHasReasonService,
    private reasonService: LoyaltyReasonService,
    private rolesMsService: RoleMSService,
    private paramService: LoyaltyParamsService
  ) { }

  get reasons(): FormArray {
    return this.form.get('reasons') as FormArray;
  }

  ngOnInit() {
    const paramListType = [
      { key: 'param_group', value: 'AccumulatorType' }
    ];

    let AcmTypeList: Observable<any>;
    if (!sessionStorage.getItem('acmTypeListTypeI') && !sessionStorage.getItem('acmTypeListTypeO')) {
      AcmTypeList = this.paramService.list(null, null, paramListType);
    }


    this.reasonForm = [];

    this.acmTypeService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.acmTypeId = this.activatedRoute.snapshot.params['acmTypeId'];
    this.editMode = (typeof this.acmTypeId !== 'undefined');
    let acmType: Observable<any>;
    let ReasonForm: Observable<any>;

    if (AcmTypeList) {
      AcmTypeList.subscribe(
        res => {
          for (const acm of res.data) {
            this.listTypeI.push({
              label: acm.description,
              value: acm.id
            });
            this.listTypeO.push({
              label: acm.description,
              value: acm.id
            });
          }
          sessionStorage.setItem('acmTypeListTypeI', JSON.stringify(this.listTypeI));
          sessionStorage.setItem('acmTypeListTypeO', JSON.stringify(this.listTypeO));
        }
      );
    }

    if (this.editMode) {

      this.acmTypeHasReasonService.getFields().subscribe(res => {
        this.reasonFields = res;
      });

      acmType = this.acmTypeService.get(this.acmTypeId);
      //parametro aggiuntivo per visualizzazione di tutti i ruoli/causali nella funzionalità TIPI ACM - KS-5454
      const params = [{key: 'noUser', value: 'true' }]
      params.push( {key: 'flg_state', value: '0' });
      //liste di reason con flg_state = 0
      ReasonForm = this.acmTypeHasReasonService.getFromAcmType(this.acmTypeId, params);

      if (!sessionStorage.getItem('acmTypeReasons')) {
        this.reasonService.list().subscribe(
          res => {
            for (const reason of res.data) {
              this.reasonsList.push({ value: Number(reason.id), label: reason.description });
            }
          },
          error => console.error(error),
          () => sessionStorage.setItem('acmTypeReasons', JSON.stringify(this.reasonsList))
        );
      }

      if (!sessionStorage.getItem('acmTypeRoles')) {
        this.rolesMsService.list().subscribe(
          res => {
            for (const role of res.data) {
              this.rolesList.push({ value: role.id, label: role.description });
            }
          },
          error => console.error(error),
          () => sessionStorage.setItem('acmTypeRoles', JSON.stringify(this.rolesList))
        );
      }

      Observable.zip(acmType, ReasonForm).subscribe(([resAcmType, resAcmHasReason]) => {

        if (!isUndefined(resAcmHasReason.data)) {
          for (const reason of resAcmHasReason.data) {
            this.reasonForm.push(this.fb.group(this.getAcmTypeReason(reason)));
          }
        }

        this.form = this.fb.group({
          acm_typei_pid: [(resAcmType && resAcmType.data && resAcmType.data.acm_typei_pid) ? resAcmType.data.acm_typei_pid : null],
          acm_typeo_pid: [(resAcmType && resAcmType.data && resAcmType.data.acm_typeo_pid) ? resAcmType.data.acm_typeo_pid : null],
          acm_type_code: [(resAcmType && resAcmType.data && resAcmType.data.acm_type_code) ? resAcmType.data.acm_type_code : ''],
          description: [(resAcmType && resAcmType.data && resAcmType.data.description) ? resAcmType.data.description : ''],
          flg_operation: [(resAcmType && resAcmType.data && resAcmType.data.flg_operation) ? resAcmType.data.flg_operation : ''],
          reasons: this.fb.array(this.reasonForm)
        });
      });

    } else {
      acmType = Observable.of(new AcmType());
      ReasonForm = Observable.of(new AcmTypehasReason());
      acmType.subscribe(resAcmType => {
        this.form = this.fb.group({
          acm_typei_pid: [(resAcmType && resAcmType.data && resAcmType.data.acm_typei_pid) ? resAcmType.data.acm_typei_pid : null],
          acm_typeo_pid: [(resAcmType && resAcmType.data && resAcmType.data.acm_typeo_pid) ? resAcmType.data.acm_typeo_pid : null],
          acm_type_code: [(resAcmType && resAcmType.data && resAcmType.data.acm_type_code) ? resAcmType.data.acm_type_code : ''],
          description: [(resAcmType && resAcmType.data && resAcmType.data.description) ? resAcmType.data.description : ''],
          flg_operation: [(resAcmType && resAcmType.data && resAcmType.data.flg_operation) ? resAcmType.data.flg_operation : ''],
        });
      });
    }

    this.flg_operations = new AcmTypeOperation(this.translate);
  }

  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const acmType = new AcmType();
    acmType.description = this.form.get('description').value;
    acmType.acm_type_code = this.form.get('acm_type_code').value;
    acmType.flg_operation = this.form.get('flg_operation').value;
    acmType.acm_typei_pid = this.form.get('acm_typei_pid').value;
    acmType.acm_typeo_pid = this.form.get('acm_typeo_pid').value;

    if (!this.editMode) {
      this.acmTypeService.create(acmType).subscribe(res => {
        this.router.navigate(['/loyalty/acm-type']);
      });
    } else {
      acmType.id = this.acmTypeId;
      this.acmTypeService.update(acmType).subscribe(res => {
        this.saveReason(this.form.get('reasons').value);
      });
    }
  }

  getAcmTypeReason(AcmhasReason: AcmTypehasReason) {
    return {
      id: [AcmhasReason.id || null],
      reason_id: [AcmhasReason.reason_id || ''],
      acm_type_id: [AcmhasReason.acm_type_id || ''],
      grant_role_id: [AcmhasReason.grant_role_id || '']
    };
  }

  addReason() {
    this.reasons.push(this.fb.group(
      this.getAcmTypeReason(new AcmTypehasReason())
    ));
  }

  deleteReason(i: number, AcmhasReason: FormGroup) {
    if (!AcmhasReason.get('id').value) {
      this.reasons.removeAt(i);
      return;
    }
    this.acmTypeHasReasonService.remove(this.acmTypeId, AcmhasReason.get('reason_id').value, AcmhasReason.get('grant_role_id').value).subscribe((res) => {
      this.reasons.removeAt(i);
    });
  }

  saveReason(reasons: Array<AcmTypehasReason>) {
    if (reasons.length > 0) {
      const requests = [];
      for (const reason of reasons) {
        reason.acm_type_id = +this.acmTypeId;
        if (!reason.id) {
          delete reason.id;
          requests.push(this.acmTypeHasReasonService.create(reason));
        } else {
          requests.push(this.acmTypeHasReasonService.update(reason.acm_type_id, reason.reason_id, reason.grant_role_id, reason));
        }
      }
      Observable.zip(...requests).subscribe((resCreateDetails) => {

        this.router.navigate(['/loyalty/acm-type/']);
      });
    } else {
      this.router.navigate(['/loyalty/acm-type/']);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-acm-type/form-acm-type-loyalty/form-acm-type-loyalty.component.ts